import { Component, Input, OnInit } from '@angular/core';
import { EdiDispatchProductMapped } from '../edi-dispatch-parcel-management/edi-dispatch-parcel-management.component';
import { OptionsList } from 'gung-common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Product } from '../../../models/product';

@Component({
  selector: 'lib-edi-dispatch-parcel-split-modal',
  templateUrl: './edi-dispatch-parcel-split-modal.component.html',
  styleUrl: './edi-dispatch-parcel-split-modal.component.scss',
  standalone: false
})
export class EdiDispatchParcelSplitModalComponent implements OnInit{
  @Input() parcelProduct: EdiDispatchProductMapped;
  @Input() product: Product;

  protected resultParcelProducts: EdiDispatchProductMapped[] = [];

  protected tooManyQuantities: boolean = false;
  protected unassignedQuantities: boolean = false;

  protected unassignedQty: number = 0;

  constructor(
    protected activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.resultParcelProducts.push(structuredClone(this.parcelProduct));
    this.checkQuantities();
  }

  addRow(): void {
    const res = structuredClone(this.parcelProduct);
    res.tempId = res.tempId + '_PR_' + (new Date().getTime());
    res.quantity = 0;
    this.resultParcelProducts.push(res);
  }

  removeRow(index: number): void {
    this.resultParcelProducts.splice(index, 1);
  }

  checkQuantities(): void {
    const qty: number = this.resultParcelProducts.reduce((sum, parcel) => sum + parcel.quantity, 0);

    if (this.parcelProduct.quantity < qty) {
      this.tooManyQuantities = true;
    } else {
      this.tooManyQuantities = false;
    }

    if (this.parcelProduct.quantity > qty) {
      this.unassignedQuantities = true;
      this.unassignedQty = this.parcelProduct.quantity - qty;
    } else {
      this.unassignedQuantities = false;
      this.unassignedQty = 0;
    }
  }

  split(): void {
    this.activeModal.close(this.resultParcelProducts);
  }
}
